import {LogicService} from "./service/api/logic.service";
import {CalculationLogicTestCaseService} from "./service/api/calculation-logic-test-case.service";
import {LogicTestCaseService} from "./service/api/logic-test-case.service";
import {CalculationLogicTypeService} from "./service/api/calculation-logic-type.service";
import {CalculationLogicTypeCommentService} from "./service/api/calculation-logic-type-comment.service";
import {LogicFlowService} from "./service/api/logic-flow.service";
// TM-1000001563: dedicated CRUD service for lg.LogicFlowTrace whose
// getObjectComponent() returns the LogicFlowTrace ObjectBaseComponent.
import {LogicFlowTraceService} from "./service/api/logic-flow-trace.service";
// Dedicated CRUD service for lg.LogicMappingTable: hosts the lookup quick test (testLookup)
// and the FK-based dependency analysis, neither of which the generic MvsCrudService provides.
import {LogicMappingTableService} from "./service/api/logic-mapping-table.service";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {LgLogicObjectComponent} from "./component/object-components/logic-object-component/lg-logic-object.component";
import {LgLogicFlowStepObjectComponent} from "./component/object-components/logic-flow-step-object-component/lg-logic-flow-step-object.component";
import {LgLogicFlowObjectComponent} from "./component/object-components/logic-flow-object-component/lg-logic-flow-object.component";
import {LgLogicFlowExecutionObjectComponent} from "./component/object-components/logic-flow-execution-object-component/lg-logic-flow-execution-object.component";
import {LgLogicFlowTestCaseObjectComponent} from "./component/object-components/logic-flow-test-case-object-component/lg-logic-flow-test-case-object.component";
// TM-1000001563: register LogicFlowTrace's OBC so trace rows can be opened
// via the standard navigation service (right pane / new browser tab) using
// the entity-resolved `objectComponent` slot.
import {LgFlowTraceDetailPanelComponent} from "./component/protected-components/lg-flow-trace-detail-panel/lg-flow-trace-detail-panel.component";
// Object component for lg.LogicMappingTable. The entity has TWO child collections (entries +
// partner overrides), so the Complex Configuration Entity Rule demands an object page instead of
// flat tabs on the config page.
import {LgLogicMappingTableObjectComponent} from "./component/object-components/logic-mapping-table-object-component/lg-logic-mapping-table-object.component";

export const LG_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['lg.LogicImport', {route: '/lg/logicImports'}],
            ['lg.LogicGroup', {route: '/lg/logicGroups'}],
            ['lg.Logic', {route: '/lg/logics', service: LogicService, objectComponent: [{component: LgLogicObjectComponent}]}],
            ['lg.LogicExport', {route: '/lg/logicExports'}],
            ['lg.LogicFlowImport', {route: '/lg/logicFlowImports'}],
            ['lg.LogicFlowExport', {route: '/lg/logicFlowExports'}],
            ['lg.LgLogicLlmTool', {route: '/lg/logicLlmTools'}],

            ['lg.CalculationLogicComment', {route: '/lg/calculationLogicComments'}],
            ['lg.CalculationLogicTestCase', {route: '/lg/calculationLogicTestCases', service: CalculationLogicTestCaseService}],
            ['lg.CalculationLogicTestCaseImportVariable', {route: '/lg/calculationLogicTestCaseImportVariables'}],
            ['lg.LogicComment', {route: '/lg/logicComments'}],

            ['lg.LogicTestCaseImportVariable', {route: '/lg/logicTestCaseImportVariables'}],
            ['lg.LogicTestCase', {route: '/lg/logicTestCases', service: LogicTestCaseService}],

            ['lg.CalculationLogicTypeStep', {route: '/lg/calculationLogicTypeSteps'}],
            ['lg.CalculationLogicType', {route: '/lg/calculationLogicTypes', service: CalculationLogicTypeService}],
            ['lg.CalculationLogicTypeField', {route: '/lg/calculationLogicTypeFields'}],
            ['lg.CalculationLogicTypeComment', {route: '/lg/calculationLogicTypeComments', service: CalculationLogicTypeCommentService}],
            ['lg.CalculationLogicTypeStepMapping', {route: '/lg/calculationLogicTypeStepMappings'}],
            ['lg.CalculationLogic', {route: '/lg/calculationLogics'}],
            ['lg.CalculationLogicField', {route: '/lg/calculationLogicFields'}],

            ['lg.LogicFlow', {route: '/lg/logicFlows', service: LogicFlowService, objectComponent: [{component: LgLogicFlowObjectComponent}]}],
            ['lg.LogicFlowStep', {route: '/lg/logicFlowSteps', objectComponent: [{component: LgLogicFlowStepObjectComponent}]}],
            ['lg.LogicFlowStepBinding', {route: '/lg/logicFlowStepBindings'}],
            ['lg.LogicFlowLogicDeclaration', {route: '/lg/logicFlowLogicDeclarations'}],
            // The object component is bound to mode 'update' ON PURPOSE. A mode-less entry matches
            // EVERY mode including 'create', which would render the object component for a row that
            // does not exist yet and leave the create dialog blank. With 'update' the create flow
            // falls through to the generic metadata form; the object page asks for 'update'
            // explicitly (see LgMappingTableObjectPagePage#refreshComponent).
            ['lg.LogicMappingTable', {
                route: '/lg/logicMappingTables',
                service: LogicMappingTableService,
                objectComponent: [{mode: MvsCrudModeEnum.update, component: LgLogicMappingTableObjectComponent}]
            }],
            // The two child entities stay without an own object component on purpose: they are
            // maintained exclusively in the widgets of the mapping table's object page.
            ['lg.LogicMappingTableEntry', {route: '/lg/logicMappingTableEntries'}],
            ['lg.LogicMappingTableOverride', {route: '/lg/logicMappingTableOverrides'}],
            ['lg.LogicFlowExecution', {route: '/lg/logicFlowExecutions', objectComponent: [{component: LgLogicFlowExecutionObjectComponent}]}],
            ['lg.LogicFlowExecutionStep', {route: '/lg/logicFlowExecutionSteps'}],
            ['lg.LogicFlowMessage', {route: '/lg/logicFlowMessages'}],
            ['lg.LogicFlowTestCase', {route: '/lg/logicFlowTestCases', objectComponent: [{component: LgLogicFlowTestCaseObjectComponent}]}],
            ['lg.LogicFlowTestCaseInput', {route: '/lg/logicFlowTestCaseInputs'}],
            ['lg.LogicFlowTestCaseExpectation', {route: '/lg/logicFlowTestCaseExpectations'}],

            // TM-1000001563: register LogicFlowTraceService so MvsCoreService can
            // resolve the OBC via the service's getObjectComponent() fallback.
            // The objectComponent registry entry is kept as the primary path.
            ['lg.LogicFlowTrace', {
                route: '/lg/logicFlowTraces',
                service: LogicFlowTraceService,
            }],
            ['lg.LogicFlowTraceLogicCounter', {route: '/lg/logicFlowTraceLogicCounters'}],
            ['lg.LogicFlowTraceStep', {route: '/lg/logicFlowTraceSteps'}],

        ] as EntityServiceEntry[],
        multi: true
    }
];
